import { Outlet, type RouteObject } from 'react-router-dom';
import { RequireAuth } from '@/auth/RequireAuth';
import type { RouteHandle } from '@/layout/routeHandle';
import { CostSummaryPage } from './cost-summary/CostSummaryPage';
import { FuelExpensesPage } from './fuel/FuelExpensesPage';
import { StatementDetailPage } from './invoices/StatementDetailPage';
import { StatementListPage } from './invoices/StatementListPage';
import { MountDetailPage } from './receipt-mounts/MountDetailPage';
import { MountListPage } from './receipt-mounts/MountListPage';
import { ReceiptDetailPage, ReceiptListPage } from './receipts/ReceiptPages';
import { SubsidyPaymentsPage } from './subsidy/SubsidyPaymentsPage';

/** 費用・支払・請求は基金・漁協のみ（02 §5：水産庁・沖縄県は利用不可） */
const guard = (
  <RequireAuth roles={['基金', '漁協']}>
    <Outlet />
  </RequireAuth>
);

/** expenses（担当: G3）。パスは `/years/:year` からの相対。S-50〜S-58 */
export const routes: RouteObject[] = [
  {
    path: 'fuel-expenses',
    handle: { crumb: '燃料費一覧' } satisfies RouteHandle,
    element: guard,
    children: [{ index: true, element: <FuelExpensesPage /> }],
  },
  {
    path: 'subsidy-payments',
    handle: { crumb: '助成金支払日登録' } satisfies RouteHandle,
    element: guard,
    children: [{ index: true, element: <SubsidyPaymentsPage /> }],
  },
  {
    path: 'invoices',
    handle: { crumb: '報告書兼請求書' } satisfies RouteHandle,
    element: guard,
    children: [
      { index: true, element: <StatementListPage type="請求書" /> },
      { path: ':id', element: <StatementDetailPage type="請求書" />, handle: { crumb: '詳細・編集' } satisfies RouteHandle },
    ],
  },
  {
    path: 'receipts',
    handle: { crumb: '助成金領収書' } satisfies RouteHandle,
    element: guard,
    children: [
      { index: true, element: <ReceiptListPage /> },
      { path: ':id', element: <ReceiptDetailPage />, handle: { crumb: '詳細・編集' } satisfies RouteHandle },
    ],
  },
  {
    path: 'forms/receipt-mounts',
    handle: { crumb: '台紙作成' } satisfies RouteHandle,
    element: guard,
    children: [
      { index: true, element: <MountListPage /> },
      { path: ':id', element: <MountDetailPage />, handle: { crumb: '詳細・編集' } satisfies RouteHandle },
    ],
  },
  {
    path: 'forms/cost-summary',
    handle: { crumb: '統括表・明細表' } satisfies RouteHandle,
    element: guard,
    children: [{ index: true, element: <CostSummaryPage /> }],
  },
];
